import React from 'react';
import { LandingHeader } from './Header';

export const Nav: React.FC<any> = ({ children }) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <LandingHeader />
      {children}
    </div>
  );
};
